export function urlCruise(pathname?: string | null | undefined) {
  if (!pathname) {
    return '/cruzeiros';
  }

  if (pathname?.startsWith('https')) {
    return pathname;
  }
  let path = pathname.replace('/cruzeiros', '').replace(/^\//g, '').trim();
  return `/cruzeiros/${path}`;
}

export function urlViagens(slug?: string) {
  if (!slug) {
    return '/viagens';
  }
  slug = slug.replace(/^\//, '');

  // Since migration Cruise TravelType to external feature
  if (slug === 'cruzeiros') {
    return '/cruzeiros';
  }
  return `/viagens/${slug}`;
}

export function urlOfertas(slug?: string) {
  if (!slug) {
    return '/ofertas';
  }
  slug = slug.replace(/^\//, '');

  return `/ofertas/${slug}.html`;
}
